








































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { ServiceRequestModel, ServiceType } from '../../types/request';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { ObjectFactory } from '@/config/objectFactory';
import { MapUtils } from '@/util/mapUtils';
import MessageBox from '../../components/MessageBox.vue';
import { DateUtils } from '@/util/dateUtils';
import { CommonUtils } from '@/util/commonUtils';
// tslint:disable-next-line: no-var-requires
const validationErrorMessages = require('../../config/validationErrorMessages.json');
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
declare var google: any;
@Component({
    props: {
        serviceRequest: Object,
    },
    components: {
        MessageBox,
    },
    data() {
        return {
            validationErrorMessages: [],
            showRequiredFieldMessage: false,
            isEstimatedTimeValid: false,
            isEstimatedTimeValidMsgAdded: false,
        };
    },
    computed: {
        lastMinuteMessage() {
            if (!this.$props.serviceRequest.transportation.rideshareService) {
                const addressBilling = this as ServiceVisit;
                const lastMinuteMessage = CommonUtils.translateMessageCode('MSG_LAST_MINUTE_REQUEST');
                if (!this.$props.serviceRequest.multipleAppointment && addressBilling.isLastMinuteRequest) {
                    return lastMinuteMessage;
                }
            }
        },
        lastMinuteMessageForMultiple() {
            if (!this.$props.serviceRequest.transportation.rideshareService) {
                const addressBilling = this as ServiceVisit;
                const lastMinuteMessage = CommonUtils.translateMessageCode('MSG_LAST_MINUTE_REQUEST');
                if (this.$props.serviceRequest.multipleAppointment && addressBilling.isLastMinuteRequest) {
                    return lastMinuteMessage;
                }
            }
        },
    },
    watch: {
        serviceRequest: {
            handler(newValue, oldValue) {
                if (this.$v.$invalid) {
                    this.$props.serviceRequest.stops.isStop1Valid = false;
                } else {
                    this.$props.serviceRequest.stops.isStop1Valid = true;
                }
            },
            deep: true,
            immediate: true,
  },
    },
    validations(): any {
        const validations: any = {
            serviceRequest: {
                roundTrip: {
                    required,
                },
                service: {
                    additionalService: {
                        required,
                    },
                    type: {
                        required,
                    },
                    selectedType: {
                        required,
                    },
                },
                transportation: {
                    isImmediateTransportation: {
                        required,
                    },
                    additionalPatients: {
                        required,
                        maxValue: (value: any) => value <=
                            this.$props.serviceRequest.transportation.additionalPassengers,
                    },
                    timescope: {
                        required,
                    },
                    conciergeService: {
                        required,
                    },
                    homeAssistance: {},
                },
                homeAssistance: {
                    address: {
                        fullAddress: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                    appointmentDate: {
                        required,
                    },
                    appointmentTime: {
                        required,
                    },
                },
                interpretation: {
                    isImmediateInterpretation: {
                        required,
                    },
                },
                telemedicine: {
                    interpreterRequired: {
                        required,
                    },
                },
                appointments: {
                    required,
                    $each: {
                        date: {
                            required,
                        },
                        time: {
                            required,
                        },
                        timezone: {
                            required,
                        },
                        returnPickupTime: {
                            required: requiredIf(() =>
                                this.$props.serviceRequest.service.type === 'Transportation' &&
                                this.$props.serviceRequest.roundTrip === true &&
                                this.$props.serviceRequest.transportation &&
                                this.$props.serviceRequest.transportation.timescope === 'Pickup',
                            ),
                        },
                    },
                },
            },
        };
        if (this.$props.serviceRequest.service.type !== 'Telemedicine') {
            delete validations.serviceRequest.telemedicine.interpreterRequired;
        }
        if (this.$props.serviceRequest.service.type === 'Telemedicine' || this.$props.serviceRequest.service.type === 'Delivery') {
            delete validations.serviceRequest.service.additionalService;
        }
        if (this.$props.serviceRequest.service.type !== 'Transportation') {
            delete validations.serviceRequest.transportation;
            delete validations.serviceRequest.homeAssistance;
            delete validations.serviceRequest.roundTrip;
        }
        if (this.$props.serviceRequest.service.type !== 'Interpretation') {
            delete validations.serviceRequest.interpretation;
        }
        if (this.$props.serviceRequest.service.type === 'Transportation') {
            const request = this.$props.serviceRequest as ServiceRequestModel;
            const transportation = request.transportation;
            if (transportation && transportation.isImmediateTransportation) {
                delete validations.serviceRequest.roundTrip;
                delete validations.serviceRequest.transportation.conciergeService;
            }
            if (transportation
                && !transportation.isImmediateTransportation
                && !this.$props.serviceRequest.roundTrip) {
                delete validations.serviceRequest.transportation.conciergeService;
            }
            if (transportation &&
                (!transportation.additionalPassengers ||
                    transportation.additionalPassengers && transportation.additionalPassengers < 1)) {
                delete validations.serviceRequest.transportation.additionalPatients;
            }
        }
        if (this.$props.serviceRequest.transportation.homeAssistance === false &&
            validations.serviceRequest.homeAssistance) {
            delete validations.serviceRequest.homeAssistance;
        }
        if (this.$props.serviceRequest.sameAsTransportAddress === true &&
            validations.serviceRequest.homeAssistance) {
            delete validations.serviceRequest.homeAssistance.address;
        }
        if (this.$props.serviceRequest.followTransportRequest === true &&
            validations.serviceRequest.homeAssistance) {
            delete validations.serviceRequest.homeAssistance.appointmentDate;
            delete validations.serviceRequest.homeAssistance.appointmentTime;
        }
        if ((this.$props.serviceRequest.service.type === 'Interpretation' &&
            this.$props.serviceRequest.interpretation.isImmediateInterpretation) ||
            (this.$props.serviceRequest.service.type === 'Transportation' &&
            this.$props.serviceRequest.transportation.isImmediateTansportation) ||
            this.$props.serviceRequest.service.type === 'Delivery' ||
            this.$props.serviceRequest.service.type === 'Telemedicine') {
            delete validations.serviceRequest.appointments;
        }
        this.$data.validationErrorMessages = [];
        this.$data.isEstimatedTimeValidMsgAdded = false;
        const isEmpty = (value: any) => {
            return value === undefined || value === null || value === '';
        };
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        const transport = serviceRequest.transportation;
        if (serviceRequest.service.type === 'Transportation' && serviceRequest.transportation &&
            serviceRequest.transportation.isImmediateTransportation) {
            serviceRequest.transportation.timescope = 'Pickup';
            serviceRequest.appointments[0].date = DateUtils.formatDate(new Date(), 'YYYY-MM-DD');
            serviceRequest.appointments[0].time = DateUtils.formatDate(new Date().getTime()
                + DateUtils.convertMinutesToMillis(1), 'HH:mm');
        }
        const checkFields = (data: any, validationRules: any, path = '') => {
            Object.keys(validationRules).forEach((fieldName) => {
                const fieldValidation = validationRules[fieldName];
                const fieldPath = path ? `${path}.${fieldName}` : fieldName;
                if (fieldName === '$each') {
                    if (fieldPath.includes('appointments')) {
                        const appointments = getField(serviceRequest, 'appointments');
                        if (appointments && Array.isArray(appointments)) {
                            appointments.forEach((appointment: any, index: number) => {
                                Object.keys(fieldValidation).forEach((subFieldName) => {
                                    const subFieldValidation = fieldValidation[subFieldName];
                                    let subFieldPath = `${fieldPath}.${subFieldName}`;
                                    if (subFieldValidation.required) {
                                        const fieldValueInAppointment = getField(appointment, subFieldName);
                                        if (isEmpty(fieldValueInAppointment)) {
                                            subFieldPath = subFieldPath.replace(/\$each\./g, '');
                                            const keys = subFieldPath.split('.');
                                            let value = validationErrorMessages;
                                            for (const key of keys) {
                                                try {
                                                    value = value[key];
                                                } catch (error) {
                                                    console.log('error while getting field');
                                                }
                                            }
                                            if (value) {
                                                if (typeof(value) !== 'string' && value.length) {
                                                    value.forEach((element: any) => {
                                                        this.$data.validationErrorMessages.push(element);
                                                    });
                                                } else {
                                                    this.$data.validationErrorMessages.push(value);
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                        }
                    }
                } else {
                    if (fieldValidation.required) {
                        const fieldValueInServiceRequest = getField(serviceRequest, fieldPath);
                        if (isEmpty(fieldValueInServiceRequest)) {
                            const additionalPatient = 'Please state the number of additional passengers being treated at the facility';
                            const conciergeServiceMsg = 'Please state does the transporter need to wait in the lobby during the appointment?';
                            const timescopeMsg = 'Please select time scope';
                            if (fieldPath === 'transportation.additionalPatients'
                                && !this.$data.validationErrorMessages.includes(additionalPatient)) {
                                this.$data.validationErrorMessages.push(additionalPatient);
                            } else if (fieldPath === 'transportation.conciergeService'
                                && !this.$data.validationErrorMessages.includes(conciergeServiceMsg)) {
                                this.$data.validationErrorMessages.push(conciergeServiceMsg);
                            } else if (fieldPath === 'transportation.timescope'
                                && !this.$data.validationErrorMessages.includes(timescopeMsg)) {
                                this.$data.validationErrorMessages.push(timescopeMsg);
                            } else {
                                let message;
                                const keys = fieldPath.split('.');
                                let value = validationErrorMessages;
                                for (const key of keys) {
                                    value = value[key];
                                }
                                if (value) {
                                    message = value;
                                }
                                if (message) {
                                    if (typeof(message) !== 'string' && message.length) {
                                        message.forEach((element: any) => {
                                            this.$data.validationErrorMessages.push(element);
                                        });
                                    } else {
                                        this.$data.validationErrorMessages.push(message);
                                    }
                                }
                            }
                        } else {
                            console.log(fieldValueInServiceRequest);
                        }
                    }
                    if (typeof fieldValidation === 'object') {
                        checkFields(data, fieldValidation, fieldPath);
                    }
                    if (serviceRequest.service.type === 'Transportation' &&
                        transport && this.$props.serviceRequest.roundTrip &&
                        this.$props.serviceRequest.transportation.timescope
                        && this.$props.serviceRequest.transportation.timescope !== 'Pickup'
                        && !this.$data.isEstimatedTimeValid
                        && !this.$data.isEstimatedTimeValidMsgAdded
                        && transport.isImmediateTransportation) {
                        let value = validationErrorMessages;
                        const keys = ['transportation', 'estimatedVisitTime'];
                        for (const key of keys) {
                            value = value[key];
                        }
                        if (value) {
                            this.$data.validationErrorMessages.push(value);
                        }
                        this.$data.isEstimatedTimeValidMsgAdded = true;
                    }

                    if (serviceRequest.service.type === 'Transportation' &&
                        transport && transport.additionalPassengers && transport.additionalPatients) {
                        const additionalPatientMsg = 'Number of additional passengers being treated cannot exceed number of total additional passengers';
                        if (transport.additionalPatients > transport.additionalPassengers
                            && !this.$data.validationErrorMessages.includes(additionalPatientMsg)) {
                            this.$data.validationErrorMessages.push(additionalPatientMsg);
                            console.log(additionalPatientMsg);
                        }
                    }
                }
            });
        };

        const getField = (data: any, fieldPath: any) => {
            const pathArray = fieldPath.split('.');
            let value = data;
            for (const pathItem of pathArray) {
                if (!value) {
                    return undefined;
                }
                value = value[pathItem];
                if (value === undefined) {
                    break;
                }
            }
            return value;
        };

        checkFields(this.$data, validations.serviceRequest);
        return validations;
    },
})
export default class ServiceVisit extends Vue {

    private inValidHours = false;
    private inValidMinutes = false;
    private isFormValid = false;
    private inValidHomeAssistanceHours = false;
    private inValidHomeAssistanceMinutes = false;
    private homeAssistanceGoogleAddress: any;
    private isInvalidValidTime = false;
    private isLastMinuteRequest = false;
    private member = ObjectFactory.getCacheService().getMemberInfo();
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private selectedTimezone = {};
    private TimeZones = TimeZones;
    private isAppointmentTimeInPast = false;
    private isLienCustomer = false;
    private invalidReturnPickupIndexes = {} as Record<number, boolean>;

    public mounted() {
        this.validateForm();
        if (this.sessionInfo.scopes.includes('member')) {
            this.getMemberRequestCount();
        }
        this.setSelectedTimezone(this.$props.serviceRequest.appointments[0].timezone);
        if (this.member.memberType && this.member.memberType === 'ORG_LIEN_CUSTOMER' ) {
            this.isLienCustomer = true;
        }
    }

    private async getMemberRequestCount() {
        if (this.member.memberType && this.member.memberType === 'ORG_CUSTOMER' && this.member.organization) {
            const orgId = this.member.organization.id;
            const resp = await ObjectFactory.getMemberService()
                .getOrganizationById(orgId, this.$store.state.serverUrl);
            if (resp.data && resp.data.lienCustomerEnabled !== true) {
                const response = await ObjectFactory.getMemberService().
                    getMemberRequestCount(this.$store.state.serverUrl);
                if (response.data) {
                    if (response.data && this.member.maximumAllowedSubmission &&
                        response.data.requestCount >= this.member.maximumAllowedSubmission) {
                        const messageBox: any = this.$refs.messageBox;
                        messageBox.showModal();
                    }
                }
            }
        }
    }

    private setHomeAssistanceGoogleAddress() {
        setTimeout(() => {
            const element = document.getElementById('homeAssistanceAddress');
            this.homeAssistanceGoogleAddress = new google.maps.places.Autocomplete(element,
                { types: ['geocode'] });
            this.homeAssistanceGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.homeAssistance.address =
                    MapUtils.parseGoogleAddress(this.homeAssistanceGoogleAddress);
            });
        });
    }

    private backToHomePage() {
        this.$router.push({ path: `/requests` });
    }

    private setServiceType(type: ServiceType, additionalService?: boolean) {
        if (type === 'CMR') {
            this.$props.serviceRequest.delivery.isCmr = true;
            type = 'Delivery';
        } else {
            this.$props.serviceRequest.delivery.isCmr = false;
        }
        this.$props.serviceRequest.service.type = type;
        if (type !== 'TransInterpreter') {
            this.$props.serviceRequest.service.selectedType = type;
        }
        this.$props.serviceRequest.service.additionalService = additionalService;
        this.resetStops();
        this.validateForm();
        if (type === 'Transportation') {
            ObjectFactory.getOrganizationService()
                .getPreferredProviders(this.$store.state.serverUrl).then((response) => {
                    this.$store.commit('SET_PREFERRED_PROVIDER', response.data);
                });
        }
    }

    private resetStops() {
        this.$props.serviceRequest.stops.isStop2Valid = false;
        this.$props.serviceRequest.stops.isStop3Valid = false;
        this.$props.serviceRequest.stops.isStop4Valid = false;
    }

    private isNumber(evt: KeyboardEvent) {
        const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
        const keyPressed: string = evt.key;
        if (!keysAllowed.includes(keyPressed)) {
            evt.preventDefault();
        }
    }

    private validateForm() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        const transportation = this.$props.serviceRequest.transportation;
        const service = this.$props.serviceRequest.service.type as ServiceType;
        this.checkIsLastMinute();
        if ((service === 'Transportation' || service === 'TransInterpreter') && this.$props.serviceRequest.roundTrip
            && this.$props.serviceRequest.transportation.timescope) {
                if (this.$props.serviceRequest.transportation.timescope !== 'Pickup') {
                    serviceRequest.appointments.forEach((appointment) => {
                        appointment.returnPickupTime = '';
                    });
                    this.invalidReturnPickupIndexes = {};
                    if ((!transportation.estimatedVisitTime.hours || transportation.estimatedVisitTime.hours <= 0) &&
                    (!transportation.estimatedVisitTime.minutes || transportation.estimatedVisitTime.minutes <= 0)) {
                        this.$data.isEstimatedTimeValid = false;
                        this.isFormValid = false;
                    } else if (transportation.estimatedVisitTime) {
                        this.validateVisitTime();
                    }
                } else {
                    this.$data.isEstimatedTimeValid = true;
                    this.isFormValid = true;
                }
        } else {
            this.$data.isEstimatedTimeValid = true;
            this.isFormValid = true;
        }
    }

    private validateVisitTime() {
        const transportation = this.$props.serviceRequest.transportation;
        const service = this.$props.serviceRequest.service.type as ServiceType;
        const hours = parseInt(transportation.estimatedVisitTime.hours, 10);
        const minutes = parseInt(transportation.estimatedVisitTime.minutes, 10);
        if (hours < 0 || hours > 23 || isNaN(hours)) {
            this.inValidHours = true;
            this.isFormValid = false;
        } else {
            this.inValidHours = false;
            this.isFormValid = true;
        }
        if (minutes < 0 || minutes > 59 || isNaN(minutes)) {
            this.inValidMinutes = true;
            this.isFormValid = false;
        } else {
            this.inValidMinutes = false;
            this.isFormValid = true;
        }
        if (this.isFormValid) {
            this.$data.isEstimatedTimeValid = true;
        }
    }

    private validateHomeAssitanceEstimateTime() {
        const homeAssistance = this.$props.serviceRequest.homeAssistance;
        const hours = parseInt(homeAssistance.estimatedVisitTime.hours, 10);
        const minutes = parseInt(homeAssistance.estimatedVisitTime.minutes, 10);
        if (hours < 0 || hours > 23 || isNaN(hours)) {
            this.inValidHomeAssistanceHours = true;
            this.isFormValid = false;
        } else {
            this.inValidHomeAssistanceHours = false;
            this.isFormValid = true;
        }
        if (minutes < 0 || minutes > 59 || isNaN(minutes)) {
            this.inValidHomeAssistanceMinutes = true;
            this.isFormValid = false;
        } else {
            this.inValidHomeAssistanceMinutes = false;
            this.isFormValid = true;
        }
    }

    private validateHomeAssistanceTime() {
        const serviceRequest = this.$props.serviceRequest;
        if (serviceRequest.homeAssistance) {
            let time = new Array();
            time = serviceRequest.homeAssistance.appointmentTime.split(':');
            const hours = parseInt(time[0], 10);
            const minutes = parseInt(time[1], 10);
            if (isNaN(hours) || 0 > hours || hours >= 24 || isNaN(minutes) || 0 > minutes || minutes >= 60) {
                serviceRequest.homeAssistance.appointmentTime.time = '';
            }
        }
    }

    private nextStep() {
        this.validateForm();
        if (this.$v.$invalid || (!this.isFormValid && this.$props.serviceRequest.roundTrip)
            || this.isInvalidValidTime || this.isAppointmentTimeInPast || this.hasInvalidReturnPickup) {
            this.$data.showRequiredFieldMessage = true;
        } else {
            this.$data.showRequiredFieldMessage = false;
            this.$props.serviceRequest.stops.isStop1Valid = true;
            const service = this.$props.serviceRequest.service.type as ServiceType;
            if (service === 'Telemedicine') {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_MEETING_DETAILS });
            } else if (service === 'Delivery') {
                this.$props.serviceRequest.stops.isStop2Valid = true;
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_PICKUP_DETAILS });
            } else if (service === 'HomeHealthCare') {
                this.$props.serviceRequest.stops.isStop2Valid = true;
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_HOME_HEALTHCARE_DETAILS });
            } else {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_VEHICLE_LANGUAGE });
            }
        }
    }


     get hasInvalidReturnPickup(): boolean {
        return Object.values(this.invalidReturnPickupIndexes).some((v) => v === true);
    }

    private addAppointmentDateTime() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments.length < 20) {
            serviceRequest.appointments.push({
                date: '',
                time: '',
                timezone: DateUtils.getLocalTimezone(),
                returnPickupTime: '',
            });
        }
    }
    private removeAppointmentDateTime(index: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments.length > 1) {
            serviceRequest.appointments.splice(index, 1);
        }
    }
    private onMultipleAppointment() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.multipleAppointment = !serviceRequest.multipleAppointment;
        serviceRequest.appointments = [{
            date: '',
            time: '',
            timezone: DateUtils.getLocalTimezone(),
            returnPickupTime: '',
        }];
    }

    private checkIsLastMinute() {
        const currentTime = DateUtils.getCurrentUTCTimeInMillis();
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.service.type === 'Transportation'
            && serviceRequest.transportation
            && !serviceRequest.transportation.isImmediateTransportation
            && serviceRequest.appointments) {
            for (const appointment of serviceRequest.appointments) {
                if (appointment.date && appointment.time) {
                    const scope = ObjectFactory.getCacheService().getSessionInfo().scopes;
                    const dateTime = DateUtils.formatDate(appointment.date + ' ' +
                        appointment.time, 'YYYY-MM-DDTHH:mm:ss.sssZ', appointment.timezone);
                    const appointmentTimestamp = Date.parse(new Date(dateTime).toUTCString());
                    const difference = DateUtils.convertMillisToMinutes(appointmentTimestamp -
                        currentTime);
                    if (difference >= 60) {
                        this.isInvalidValidTime = false;
                        this.isAppointmentTimeInPast = false;
                    } else if (difference < 60 && difference >= 0) {
                        this.isAppointmentTimeInPast = false;
                        if (scope.includes('admin')) {
                            this.isInvalidValidTime = false;
                        } else {
                            this.isInvalidValidTime = true;
                            break;
                        }
                    } else if (appointmentTimestamp < currentTime) {
                        this.isInvalidValidTime = false;
                        if (scope.includes('admin')) {
                            this.isAppointmentTimeInPast = false;
                        } else {
                            this.isAppointmentTimeInPast = true;
                            break;
                        }
                    } else {
                        this.isInvalidValidTime = false;
                        this.isAppointmentTimeInPast = false;
                        break;
                    }
                } else {
                    break;
                }
            }
            for (const appointment of serviceRequest.appointments) {
                if (appointment.date && appointment.time) {
                    const dateTime = DateUtils.formatDate(appointment.date + ' ' +
                        appointment.time, 'YYYY-MM-DDTHH:mm:ss.sssZ', appointment.timezone);
                    const appointmentTimestamp = Date.parse(new Date(dateTime).toUTCString());
                    const difference = DateUtils.convertMillisToMinutes(appointmentTimestamp -
                        currentTime);
                    if (difference < 180 && difference >= 0) {
                        this.isLastMinuteRequest = true;
                        break;
                    } else {
                        this.isLastMinuteRequest = false;
                    }
                } else {
                    this.isLastMinuteRequest = false;
                }
            }
        } else {
            this.isInvalidValidTime = false;
        }
    }
    private validateTime(index?: number) {
        const objIndex = index ? index : 0;
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments) {
            let time = new Array();
            time = serviceRequest.appointments[objIndex].time.split(':');
            const hours = parseInt(time[0], 10);
            const minutes = parseInt(time[1], 10);
            if (isNaN(hours) || 0 > hours || hours >= 24 || isNaN(minutes) || 0 > minutes || minutes >= 60) {
                serviceRequest.appointments[objIndex].time = '';
            }
        }
    }

    private validateReturnTripPickupTime(index: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        const appointment = serviceRequest.appointments[index];
        this.$set(this.invalidReturnPickupIndexes, index, false);
        if (!appointment || !appointment.date || !appointment.time ||
            !appointment.returnPickupTime) {
            return;
        }
        const outbound = new Date(`${appointment.date}T${appointment.time}`);
        const returnPickup = new Date(`${appointment.date}T${appointment.returnPickupTime}`);
        if (returnPickup <= outbound) {
            this.$set(this.invalidReturnPickupIndexes, index, true);
        }
    }


    private validateDate() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.patient.birthdate) {
            const birthdate = new Date(serviceRequest.patient.birthdate);
            const today = new Date();
            if (birthdate > today) {
                serviceRequest.patient.birthdate = '';
            }
        }
    }

    private setSelectedTimezone(timezone: string) {
        if (timezone) {
            this.TimeZones.forEach((continent: any) => {
                continent.timezones.forEach((timezoneObj: any) => {
                    if (timezoneObj.value === timezone
                        || (timezoneObj.utc && timezoneObj.utc.includes(timezone))) {
                        this.selectedTimezone = timezoneObj;
                    }
                });
            });
        }
    }

    private setTimezone(timezone: any) {
        this.$props.serviceRequest.appointments[0].timezone = timezone.utc[0];
    }
}
